const STOPWORDS: Record<string, string[]> = {
    'Português - Brasil': ['você', 'grátis', 'receba', 'escolha', 'seus', 'são', 'está', 'para', 'não', 'uma', 'com', 'resgate', 'agora', 'receba', 'confira'],
    'Espanhol - Espanha': ['usted', 'gratis', 'recibe', 'elige', 'sus', 'también', 'con', 'corre', 'rescata', 'ahora', 'recíbelos', 'elige'],
    'Francês - França': ['vous', 'gratuit', 'recevez', 'choisissez', 'vos', 'avec', 'pour', 'dépêche', 'récupère', 'gratuits'],
    'Inglês - Estados Unidos': ['you', 'free', 'receive', 'choose', 'your', 'the', 'and', 'get', 'claim', 'now'],
    'Inglês - Reino Unido': ['you', 'free', 'receive', 'choose', 'your', 'the', 'and', 'get', 'claim', 'now'],
    'Alemão - Alemanha': ['sie', 'kostenlos', 'erhalten', 'wählen', 'ihre', 'mit', 'für', 'das', 'und', 'jetzt'],
    'Italiano - Itália': ['gratis', 'ricevete', 'scegliete', 'vostra', 'con', 'per', 'anche', 'subito', 'scegli'],
    'Holandês - Países Baixos': ['gratis', 'ontvangen', 'kiezen', 'uw', 'met', 'voor', 'ook', 'nu', 'kies'],
};

export function detectLanguage(text: string): string | null {
    if (!text || text.trim().length < 15) return null;
    const lower = text.toLowerCase();

    const scores: Record<string, number> = {};
    for (const [lang, words] of Object.entries(STOPWORDS)) {
        scores[lang] = words.filter(w => lower.includes(w)).length;
    }

    const sorted = Object.entries(scores).sort((a, b) => b[1] - a[1]);
    const [best, second] = sorted;

    if (!best || best[1] < 2) return null;
    // PT e ES são próximos — exige margem de 1 ponto
    if (
        second &&
        second[1] >= best[1] - 1 &&
        ((best[0].startsWith('Português') && second[0].startsWith('Espanhol')) ||
            (best[0].startsWith('Espanhol') && second[0].startsWith('Português')))
    ) {
        // desempate: "você"/"grátis" são exclusivamente PT; "usted"/"rescata" são exclusivamente ES
        const ptExclusive = ['você', 'grátis', 'resgate', 'receba'];
        const esExclusive = ['usted', 'rescata', 'elige', 'gratis'];
        const ptHits = ptExclusive.filter(w => lower.includes(w)).length;
        const esHits = esExclusive.filter(w => lower.includes(w)).length;
        if (ptHits > esHits) return 'Português - Brasil';
        if (esHits > ptHits) return 'Espanhol - Espanha';
        return null;
    }

    // EN/UK são idênticos — colapsa para US
    if (best[0] === 'Inglês - Reino Unido') return 'Inglês - Estados Unidos';

    return best[0];
}
